import {initCookiePolicy} from './div.cookie-policy';
import {initNotification} from './div.notification';
import {initRangeOne} from './div.range-one';
import {initRange} from './div.new-range';
import {initLazyImages} from './img.lazy-image';
import {initCopyButton} from './span.copy';
// import {initPause} from './div.pause';

export const initElements = () => {
	initNotification();
	initLazyImages();
	initRangeOne();
	initRange();
	initCookiePolicy();
	// initPause();
	initCopyButton();
};
